export default function ICopy({ color = "#252526", width = 16, height = 16, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M11.1667 13.6667C11.1667 14.1269 10.7936 14.5 10.3333 14.5H2.33333C1.8731 14.5 1.5 14.1269 1.5 13.6667V5.66667C1.5 5.20643 1.8731 4.83333 2.33333 4.83333H8C8.27614 4.83333 8.5 5.05719 8.5 5.33333C8.5 5.60948 8.27614 5.83333 8 5.83333H2.5V13.5H10.1667V8C10.1667 7.72386 10.3905 7.5 10.6667 7.5C10.9428 7.5 11.1667 7.72386 11.1667 8V13.6667Z"
        fill={color}
      />
      <path
        d="M14.5 6V2C14.5 1.72386 14.2761 1.5 14 1.5H10C9.72386 1.5 9.5 1.72386 9.5 2C9.5 2.27614 9.72386 2.5 10 2.5H13.5V6C13.5 6.27614 13.7239 6.5 14 6.5C14.2761 6.5 14.5 6.27614 14.5 6Z"
        fill={color}
      />
      <path
        d="M13.6465 1.64648C13.8417 1.45122 14.1583 1.45122 14.3535 1.64648C14.5488 1.84175 14.5488 2.15825 14.3535 2.35352L8.35352 8.35352C8.15825 8.54878 7.84175 8.54878 7.64648 8.35352C7.45122 8.15825 7.45122 7.84175 7.64648 7.64648L13.6465 1.64648Z"
        fill={color}
      />
    </svg>
  );
}
